<!-- <div class="container mt-5"> -->
    <div class="accordion accordion-flush mt-4" id="accordionSubaccounts">

        @for (subaccount of subaccounts; track subaccount;) {

            <div class="accordion-item">
                <h2 class="accordion-header" [id]="'heading' + subaccount.subacctId">
                    <button class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            aria-expanded="true"
                            [attr.data-bs-target]="'#collapse' + subaccount.subacctId"
                            [attr.aria-controls]="'collapse' + subaccount.subacctId">
                        {{subaccount.subacctName}}
                    </button>
                </h2>
<!--
                            class="accordion-button collapsed"  aria-expanded="false"
 -->

                <div [id]="'collapse' + subaccount.subacctId"
                     class="accordion-collapse collapse"
                     [ngClass]="{'show': $index === 0}"
                     [attr.aria-labelledby]="'heading' + subaccount.subacctId"
                     data-bs-parent="#accordionSubaccounts">
                    <div class="accordion-body">

                        @for (pageElement of subaccount.pageElemSpecs; track pageElement) {

                            <div class="row">
                                <app-page-element [pageElement]="pageElement"></app-page-element>
                            </div>

                        }@empty {
                        }

                    </div>
                </div>
            </div>

        } @empty {
        }

    </div>

    <div class="card-footer">
        <div class="row">
            <div class="col-6 text-center">
              <button type="button" icon="fa fa-close" class="wp-btn wp-btn-cancel" (click)="onClose()" label="Close">Cancel</button>
            </div>
        </div>
    </div>

<!-- </div> -->
